import wx from 'weixin-js-sdk'
import axios from 'axios';
import wxShare from './wx.share'
import store from '../../store/index'
import orderApi from '../../axios/order'
let token = store.state.token;
const getWXConfig = function (path,callback,shareBody) {
    let params = {
        // redirectUrl	: path.path
        redirectUrl	: window.location.href
     }
     let url =  process.env.VUE_APP_URL;
     axios.get(`${url}/nice-api-customer/v1/weChat/jsApiSignature`,{params:params}).then((res)=>{
        let resd = res.data.data;
        let params_share = {
            token : token,
            serviceState : res.data.code,
            path : path.path
        }
        // orderApi.shareLog(params_share).then((r)=>{

        // })
        wx.config({
            debug: false,  // 开启调试模式
            appId: resd.appId,    // 必填，公众号的唯一标识
            timestamp: resd.timestamp,  // 必填，生成签名的时间戳
            nonceStr: resd.nonceStr, // 必填，生成签名的随机串
            signature: resd.signature,// 必填，签名，见附录1
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "chooseWXPay"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            openTagList:[
                'wx-open-launch-weapp',  //跳转小程序
                'wx-open-launch-app'      //跳转app
            ]
        });
        wx.ready(res => {
            if(callback){
                callback();
            }else{
                wxShare(shareBody);
            }
            let params_share = {
                token : token,
                weChatState :'设置权限成功',
                path : path.path
            }
            // orderApi.shareLog(params_share).then((r)=>{
                
            // })
            
        })
        //注入权限错误
        wx.error(function (res) {
            let params_share = {
                token : token,
                weChatState :res.errMsg,
                path : path.path
            }
            // orderApi.shareLog(params_share).then((r)=>{
    
            // })
            // console.log(res)
            // if (res.errMsg === "config:invalid signature") {     //签名错误
            //     alert('微信签名错误')
            // }
        });
     }).catch((e)=>{
        //  alert('配置项获取失败！')
     })

};

export default getWXConfig
